<script setup lang="ts"></script>

<template>
  <p class="line-clamp-2 break-words text-md font-semibold">
    <slot />
  </p>
</template>
